export const MARRIAGE: {
    [s: string]: string;
} = {
    1: '未婚',
    2: '既婚'
};